export default function teamPopup(block, pop, exit, overflow) {
  //   const body = document.getElementsByTagName('body');
  const personBlock = document.getElementsByClassName(block);
  if (!personBlock) return;
  const popup = document.getElementsByClassName(pop);
  const popupBtnExits = document.getElementsByClassName(exit);
  const popupOverflowExits = document.getElementsByClassName(overflow);

  // disable scroll
  function disableScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
    document.body.classList.add('stop-scrolling');
    window.onscroll = () => {
      window.scrollTo(scrollLeft, scrollTop);
    };
  }

  // enable scroll
  function enableScroll() {
    document.body.classList.remove('stop-scrolling');
    window.onscroll = () => {};
  }

  // open popup
  if (personBlock) {
    for (let i = 0; i < personBlock.length; i += 1) {
      const imgBlock = personBlock[i].getElementsByClassName('site-popup-img-trigger');
      const btn = personBlock[i].getElementsByClassName('site-popup-url-trigger');

      popup[i].style.height = window.innerHeight;

      window.addEventListener('resize', () => {
        popup[i].style.height = window.innerHeight;
      });

      imgBlock[0].addEventListener('click', () => {
        popup[i].classList.add('open');
        disableScroll();
      });

      btn[0].addEventListener('click', () => {
        popup[i].classList.add('open');
        disableScroll();
      });

      popupBtnExits[i].addEventListener('click', () => {
        popup[i].classList.remove('open');
        enableScroll();
      });

      popupOverflowExits[i].addEventListener('click', () => {
        popup[i].classList.remove('open');
        enableScroll();
      });
    }
  }
}
